<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-message-processing" icon-small title="لیست قالب های پیامک" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-tabs v-model="activeTab" @change="tabChanged" background-color="transparent" centered slider-color="yellow">
						<v-tab :key="0">قالب های در انتظار تایید ({{ pendingPatterns.length }})</v-tab>
						<v-tab :key="1">همه قالب ها ({{ countAll }})</v-tab>

						<v-tabs-items v-model="activeTab" touchless>
							<v-tab-item :key="0">
								<v-row>
									<v-col cols="12" lg="12">
										<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
									</v-col>
									<v-col cols="12">
										<v-data-table dense :headers="headers" :items="pendingPatterns" :items-per-page="500" :search="search" class="elevation-1">
											<template v-slot:item="row">
												<tr>
													<td>
														<div>{{ row.item.customer.name }}</div>
														<div>{{ row.item.customer.mobile }}</div>
													</td>
													<td>
														{{ row.item.title }}
													</td>
													<td>
														<div style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
															{{ row.item.pattern }}
														</div>
													</td>
													<td class="text-center">
														{{ row.item.isSystem ? 'بلی' : 'خیر' }}
													</td>
													<td class="text-center">
														{{ translateStatus(row.item.status) }}
													</td>
													<td style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
														{{ row.item.rejectReason }}
													</td>
													<td class="text-center">
														<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-tab-item>
							<v-tab-item :key="1">
								<v-row>
									<v-col cols="12" lg="12">
										<v-text-field v-model="search2" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
									</v-col>
									<v-col cols="12">
										<v-data-table dense :headers="headers" :items="allPatterns" :items-per-page="500" :search="search2" class="elevation-1">
											<template v-slot:item="row">
												<tr>
													<td>
														<div>{{ row.item.customer.name }}</div>
														<div class="grey--text">{{ row.item.customer.mobile }}</div>
													</td>
													<td>
														{{ row.item.title }}
													</td>
													<td>
														<div style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
															{{ row.item.pattern }}
														</div>
													</td>
													<td class="text-center">
														{{ row.item.isSystem ? 'بلی' : 'خیر' }}
													</td>
													<td class="text-center">
														{{ translateStatus(row.item.status) }}
													</td>
													<td style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
														{{ row.item.rejectReason }}
													</td>
													<td class="text-center">
														<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-tab-item>

						</v-tabs-items>
					</v-tabs>

				</v-col>
			</v-row>
			<v-dialog v-model="dialogPattern" scrollable persistent max-width="450px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات قالب پیامک</span>
						<v-spacer />
						<v-btn @click="dialogPattern = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-form ref="form" class="mx-2" lazy-validation>
							<v-container>
								<v-row>
									<v-col cols="12">
										<v-text-field v-model="localData.title" outlined label="عنوان قالب*" :error-messages="errorMessages" :rules="[() => !!localData.title || 'عنوان قالب را وارد کنید']" required />
									</v-col>
									<v-col cols="12">
										<v-combobox v-model="localData.category" required :items="categories" label="دسته قالب" single-line :error-messages="errorMessages" item-text="title" item-value="id" />
									</v-col>
									<v-col>
										<v-textarea v-model="localData.pattern" outlined :error-messages="errorMessages" label="الگوی قالب*" :rules="[() => !!localData.pattern || 'قالب را وارد کنید']" required />
										<div style="font-size: 0.8rem;" class="mb-2">
											<div>نمونه پیامک:</div>
											<div v-html="sampleText" style="white-space: pre-line;">

											</div>
										</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-textarea v-model="localData.rejectReason" outlined :error-messages="errorMessages" label="دلیل رد" />
									</v-col>
								</v-row>
							</v-container>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn color="blue" dark @click="submit(1)">
							تائید شود
						</v-btn>
						<v-btn color="red" dark @click="submit(2)">
							رد شود
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import { smsReplacePattern, smsCategories } from '@/util/enums'

export default {
	name: 'SmsPatternsView',
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
	},
	data() {
		return {
			activeTab: 0,
			countAll: 0,
			allPatternsFetched: false,
			pendingPatternsFetched: false,
			errorMessages: '',
			datePickerValidatioin: '',
			localData: {},
			selectedPattern: {},
			dialogPattern: false,
			search: '',
			search2: '',
			loading: false,
			headers: [
				{
					text: 'مشتری',
					align: 'start',
					sortable: true,
					value: 'firstName',
					width: 150
				}, {
					text: 'عنوان',
					align: 'start',
					sortable: true,
					value: 'title',
					width: 150
				}, {
					text: 'قالب',
					align: 'start',
					sortable: true,
					value: 'pattern',
				}, {
					text: 'سیستمی',
					align: 'center',
					sortable: true,
					value: 'isSystem',
				}, {
					text: 'وضعیت',
					align: 'center',
					sortable: true,
					value: 'status',
					width: 100
				}, {
					text: 'دلیل رد',
					align: 'start',
					sortable: true,
					value: 'rejectReason',
					width: 200,
				}, {
					text: 'عملیات ها',
					align: 'center',
					sortable: false,
					width: 150,
				},
			],
			allPatterns: [],
			pendingPatterns: [],
			replace: smsReplacePattern,
			categories: smsCategories,
		}
	},
	computed: {
		patternTags() {
			if (this.localData.category?.value === 1) // وضعیت درخواست
				return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ هر قسط}', '{مبلغ درخواستی}', '{تعداد قسط}', '{تاریخ درخواست}', '{نوع وام}', '{شماره درخواست}', '{تاریخ تغییر وضعیت}', '{نام نماینده}', '{وضعیت جدید}', '{وضعیت جدید نماینده}', '{سررسید واریز نماینده}', '{توسط نماینده با لیبل}']

			if (this.localData.category?.value === 2 || this.localData.category?.value === 3) // ورود - ثبت نام
				return ['{نام و نام خانوادگی}', '{نام کاربری}', '{تاریخ}', '{تاریخ و ساعت}', '{آی پی}', '{مرورگر}', '{نام فروشگاه}', '{نام تجاری نماینده}']

			if (this.localData.category?.value === 4) // کد تائیدیه ثبت نام
				return ['{رمز تاییدیه}', '{تاریخ}', '{تاریخ و ساعت}', '{آی پی}', '{مرورگر}', '{نام فروشگاه}']

			if (this.localData.category?.value === 5) // شارژ کیف پول
				return ['{نام مشتری}', '{نام فروشگاه}', '{لینک پرداخت}', '{بخش متغیر لینک پرداخت}', '{تاریخ}']

			if (this.localData.category?.value === 6) // ثبت سفارش جدید
				return ['{نام مشتری}', '{نام فروشگاه}', '{کد ملی}', '{تاریخ}', '{کالای مورد درخواست}']

			if (this.localData.category?.value === 7) // ثبت پرونده
				return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ هر قسط}', '{شماره وام}', '{نوع وام}', '{تاریخ شروع}', '{مبلغ وام}', '{بازپرداخت با بهره}', '{تعداد اقساط}', '{مبلغ باقیمانده}', '{نام تجاری نماینده}']

			if (this.localData.category?.value === 8) // برداشت از کیف پول
				return ['{نام مشتری}', '{نام تجاری نماینده}', '{مبلغ}', '{تاریخ}', '{مانده اعتبار کیف پول}', '{کد تائیدیه}', '{کد رهگیری}']

			if (this.localData.category?.value === 9) // لینک واریز صورتحساب
				return ['{نام مشتری}', '{نام تجاری نماینده}', '{لینک پرداخت}', '{تاریخ}', '{مبلغ صورتحساب}', '{شماره سیستمی صورتحساب}']

			if (this.localData.category?.value === 10) // لینک_قرارداد
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{لینک قرارداد}', '{بخش متغیر لینک قرارداد}']

			if (this.localData.category?.value === 11) // کد_تائیدیه_قرارداد
				return ['{رمز تاییدیه}', '{تاریخ}', '{تاریخ و ساعت}', '{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}']

			if (this.localData.category?.value === 12) // اطلاعیه_تکمیل_قرارداد
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}']

			if (this.localData.category?.value === 13) // لینک_قرارداد ضامن
				return ['{رمز تاییدیه}', '{تاریخ}', '{تاریخ و ساعت}', '{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{نام و نام خانوادگی ضامن}', '{کد ملی ضامن}', '{موبایل ضامن}']

			if (this.localData.category?.value === 14) // کد_تائیدیه_قرارداد ضامن
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{لینک قرارداد}', '{بخش متغیر لینک قرارداد}', '{نام و نام خانوادگی ضامن}', '{کد ملی ضامن}', '{موبایل ضامن}']

			if (this.localData.category?.value === 15) // اطلاعیه_تکمیل_قرارداد ضامن
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام فروشگاه}', '{نام تجاری نماینده}', '{شماره درخواست}', '{نام طرح وام}', '{مبلغ درخواست وام}', '{تعداد قسط}', '{مبلغ هر قسط}', '{تاریخ درخواست}', '{نام و نام خانوادگی ضامن}', '{کد ملی ضامن}', '{موبایل ضامن}']

			if (this.localData.category?.value === 16) //اطلاعیه_ثبت_وام_جدید
				return ['{نام مشتری}', '{کد ملی مشتری}', '{نام تجاری نماینده}', '{نوع وام}', '{شماره درخواست}', '{تاریخ و ساعت درخواست}', '{مبلغ درخواستی}', '{تعداد قسط}', '{وضعیت درخواست}']

			return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ قسط}', '{مبلغ مانده قسط}', '{شماره قسط}', '{مبلغ واریز}', '{مبلغ آخرین واریز}', '{تاریخ واریز}', '{مانده وام}', '{لینک پرداخت}', '{بخش متغیر لینک پرداخت}', '{شماره پیگیری تراکنش}', '{نام تجاری نماینده}']
		},
		sampleText() {
			return this.convertPatternToSample(this.localData?.pattern)
		},
	},
	mounted() {
		this.tabChanged(0)
	},
	methods: {
		convertPatternToSample(pattern) {
			const replaceAll = (str, find, replace) => {
				return str.toString().replace(new RegExp(find, 'g'), replace)
			}
			if (!pattern)
				return ''
			for (var tag of this.patternTags) {
				pattern = replaceAll(pattern, tag, this.replace[tag])
			}
			return pattern
		},
		loadData(all) {
			this.loading = true
			let data = all || false
			api.get('superadmin/SmsPattern/list/' + data, null)
				.then(
					response => {
						if (all) {
							this.allPatterns = response.smsPatterns
							this.countAll = response.countAll
							this.allPatternsFetched = true
						} else {
							this.pendingPatterns = response.smsPatterns
							this.countAll = response.countAll
							this.pendingPatternsFetched = true
						}
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loading = false })
		},
		edit(item) {
			api.get('superadmin/SmsPattern/get/' + item.id, null)
				.then(
					response => {
						this.localData = response
						this.localData.category = this.categories.find(x => x.value === this.localData.category)
						this.dialogPattern = true
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		submit(status) {
			if (!this.$refs.form.validate()) { return }

			let data = { ...this.localData }
			data.status = status
			data.category = this.localData.category.value
			api.post('superadmin/SmsPattern/' + (this.localData.id === 0 ? 'create' : 'edit'), data)
				.then(
					response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.loadData(this.activeTab == 1)
						this.dialogPattern = false
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		async remove(item) {
			if (!item) { return }

			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از حذف این آیتم مطمئن هستید؟',
			)) {
				api.post('superadmin/SmsPattern/delete/' + item.id)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.allPatternsFetched = false
							this.pendingPatternsFetched = false
							this.pendingPatterns = this.activeTab == 1 ? [] : this.pendingPatterns
							this.allPatterns = this.activeTab == 0 ? [] : this.allPatterns
							this.loadData(this.activeTab == 1)
						})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
		tabChanged(tab) {
			if (tab == 1 && !this.allPatternsFetched)
				this.loadData(true)
			else if (tab == 0 && !this.pendingPatternsFetched)
				this.loadData(false)
		},
		translateStatus(status) {
			switch (status) {
				case 0:
					return 'در انتظار بررسی'
				case 1:
					return 'تائید شده'
				case 2:
					return 'رد شده'
				default:
					break
			}
		},
		updatePattern(pattern) {

		}
	},
}
</script>
<style></style>
